import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'
import storage from '@/plugins/storage'
import globals from '../plugins/globals'

const devicetypeDefault = {
  deviceType: null,
  category: null,
  deviceTypeName: null,
  internalName: null,
  internalProgram: null,
  FollowedWizard: null
}
const insuranceDefault = {
  insurance: null,
  insuranceName: null,
  firm: 1,
  isInactive: false
}
export const lookupStore = defineStore('lookup', {
  state: () => ({
    lookups: {},
    userRoles: [],
    apps: [],
    technicians: null,
    queues: [],
    loading: {
      technicians: false,
      apps: false,
      lookups: false,
      userRoles: false,
      distributionChannels: false,
      insurance: false,
      insuranceLookup: false
    },
    adasMatrixCategories: [],
    services: [],
    devicetypes: [],
    distributionChannels: [],
    newDeviceType: JSON.parse(JSON.stringify(devicetypeDefault)),
    newInsurance: JSON.parse(JSON.stringify(insuranceDefault)),
    search: '',
    mapFields: [
      {
        id: 0,
        name: 'ADASLevel1AmtUSD',
        value: 'ADASLevel1AmtUSD'
      },
      {
        id: 1,
        name: 'ADASLevel2AmtUSD',
        value: 'ADASLevel2AmtUSD'
      },
      {
        id: 2,
        name: 'ADASLevel3AmtUSD',
        value: 'ADASLevel3AmtUSD'
      },
      {
        id: 3,
        name: 'CalibrationCheckUSD',
        value: 'CalibrationCheckUSD'
      },
      {
        id: 4,
        name: 'DiagnosticAssistanceAmtUSD',
        value: 'DiagnosticAssistanceAmtUSD'
      },
      {
        id: 5,
        name: 'FastPassAmtUSD',
        value: 'FastPassAmtUSD'
      },
      {
        id: 6,
        name: 'IVSMapAmtUSD',
        value: 'IVSMapAmtUSD'
      },
      {
        id: 7,
        name: 'ProgrammingAmtUSD',
        value: 'ProgrammingAmtUSD'
      },
      {
        id: 8,
        name: 'SubscriptionFeeUSD',
        value: 'SubscriptionFeeUSD'
      },
      {
        id: 9,
        name: 'billedamountUSD',
        value: 'billedamountUSD'
      }
    ],
    selectedInsurance: null,
    sourceInsurance: [],
    insurance: [],
    insuranceLookup: []
  }),
  actions: {
    async getLookups(data) {
      const store = authStore()
      let _lookups = {}
      let _keys = data.keys.filter((k) => !this.lookups[k])
      let reset = false
      if (data.refresh) {
        reset = data.refresh
      }
      if (_keys.length || reset) {
        this.loading.lookups = true
        let results = await api.post(`lookup/byKeys`, {
          app: data.app ? data.app : null,
          keys: data.keys,
          firm: data.firm ? parseInt(data.firm) : parseInt(store.profile.firm),
          showInactive: false
        })
        this.loading.lookups = false
        if (results) {
          for (let key of data.keys) {
            _lookups[key] = []
            for (let item of results) {
              if (item.key.toLowerCase() === key.toLowerCase()) {
                item.codename = item.name
                item.name = item.value || item.name
                item.value = item.id || item.value
                item.isInactive = false
                _lookups[key].push(item)
              }
            }
          }
          this.lookups = JSON.parse(JSON.stringify(Object.assign(this.lookups, _lookups)))
        }
      }
      console.log('Got Lookups', this.lookups)
      return this.lookups
    },
    async getRoles(firm) {
      this.userRoles = []
      this.loading.userRoles = true
      this.userRoles = await api.get(`lookup/roles?firm=${firm}`)
      this.loading.userRoles = false
      return this.userRoles
    },
    async getApps(appNumber) {
      this.apps = []
      this.loading.apps = true
      this.apps = await api.get(`app/apps?appNumber=${appNumber}`)
      this.loading.apps = false
      console.log('Got Apps', this.apps)
      return this.apps
    },
    async getUserQueueOptions() {
      let queues = await api.get('user/ticketQueues')
      console.log('Got User Queue Options', queues)
      this.queues = queues
    },
    getTechniciansOffice(drewId) {
      if (this.technicians === null) {
        return ''
      }
      let found = this.technicians.filter((tech) => tech.value == drewId)
      console.log('Found Tech ', found)
      return found.length > 0 ? found[0].office : 'No Office Found!'
    },
    async getTechnicians(reset) {
      if (this.technicians === null || reset) {
        this.technicians = []
        this.queues = []
        this.loading.technicians = true
        let techs = await api.get('lookup/technicians')
        if (techs) {
          if (Array.isArray(techs)) {
            techs = globals.stringSort(techs, 'LastName')
            techs.forEach((tech) => {
              this.technicians.push({
                id: tech.ContactID,
                name: `${tech.LastName}, ${tech.FirstName}`,
                value: tech.DrewTechnicianID,
                office: tech.Office
              })
            })
          }
        }
        storage.session.setItem('technicians', JSON.stringify(this.technicians))
        this.loading.technicians = false
        console.log('Got Technicians', this.technicians)
        console.log('Got Queues', this.queues)
      } else {
        this.technicians = JSON.parse(storage.session.getItem('technicians')) || null
      }
      return this.technicians
    },
    async getAdasMatrixCategories() {
      this.adasMatrixCategories = []
      this.adasMatrixCategories = await api.get('lookup/adasMatrixCategories')
      return this.adasMatrixCategories
    },
    async getServices() {
      this.services = []
      this.services = await api.get('service/services')
      return this.services
    },
    async getDeviceTypes() {
      this.devicetypes = []
      this.devicetypes = await api.get('service/devicetypes')
      return this.devicetypes
    },
    resetDistributionChannels() {
      this.distributionChannels = []
    },
    async searchDistributionChannels(search) {
      this.distributionChannels = []
      this.loading.distributionChannels = false
      let results = await api.get(`service/distributionChannelSearch?search=${search}`)
      if (results) {
        if (Array.isArray(results)) {
          results.forEach((element) => {
            this.distributionChannels.push({
              id: parseInt(element.ID),
              name: element.Name
            })
          })
        }
      }
      this.loading.distributionChannels = false
      console.log('Got Distribution Channels', this.distributionChannels)
      return this.distributionChannels
    },
    setDeviceType(data) {
      switch (data.name) {
        case 'add':
          this.newDeviceType = JSON.parse(JSON.stringify(devicetypeDefault))
          break
        case 'edit':
          this.newDeviceType = JSON.parse(JSON.stringify(data.value))
          break
        case 'category':
          this.newDeviceType.category = data.value
          break
        case 'deviceTypeName':
          this.newDeviceType.deviceTypeName = data.value
          break
        case 'internalName':
          this.newDeviceType.internalName = data.value
          break
        case 'internalProgram':
          this.newDeviceType.internalProgram = data.value
          break
        case 'followWizard':
          this.newDeviceType.FollowWizard = data.value
          break
      }
    },
    setInsurance(data) {
      switch (data.name) {
        case 'reset':
          this.search = ''
          // for some reason, the following is extremely slow during render (not sure why)
          // this.insurance = []
          // this.insurance = JSON.parse(JSON.stringify(this.sourceInsurance))
          break
        case 'add':
          this.newInsurance = JSON.parse(JSON.stringify(insuranceDefault))
          break
        case 'selected': {
          this.selectedInsurance = null
          this.insuranceLookup = []
          this.insurance.forEach((element) => {
            element.isSelected = false
          })
          let found = this.insurance.find((x) => parseInt(x.insurance) === parseInt(data.value))
          if (found) {
            this.selectedInsurance = found.insurance
            found.isSelected = true
          }
          break
        }
        case 'search': {
          this.search = data.value.trim()
          if (this.search !== '') {
            this.insurance = []
            this.insurance = this.sourceInsurance.filter((element) => element.insuranceName.toLowerCase().includes(this.search.toLowerCase()))
          }
          break
        }
        case 'id':
          this.newInsurance.insurance = data.value
          break
        case 'name':
          this.newInsurance.insuranceName = data.value
          break
        case 'inactive':
          this.isInactive = data.value
          break
      }
    },
    async getInsurance(firm) {
      if (firm === null || firm === undefined) {
        firm = 1
      }
      this.selectedInsurance = null
      this.insuranceLookup = []
      this.sourceInsurance = []
      this.insurance = []
      this.loading.insurance = true
      this.sourceInsurance = await api.get(`lookup/insurance?firm=${firm}`)
      if (this.sourceInsurance) {
        this.sourceInsurance.forEach((element) => {
          element.isSelected = false
        })
      }
      this.insurance = JSON.parse(JSON.stringify(this.sourceInsurance))
      this.loading.insurance = false
      return this.insurance
    },
    async saveInsurance() {
      let response = await api.post('lookup/insurance', this.newInsurance)
      return response
    },
    async deleteInsurance(id) {
      let response = await api.get(`lookup/removeInsurance?id=${id}`)
      return response
    },
    async getInsuranceLookups(insurance) {
      this.insuranceLookup = []
      this.loading.insuranceLookup = true
      this.insuranceLookup = await api.get(`lookup/insuranceLookup?insurance=${insurance}`)
      this.loading.insuranceLookup = false
      if (this.insuranceLookup === null || this.insuranceLookup.length === 0) {
        this.insuranceLookup = []
      }
      return this.insuranceLookup
    },
    async deleteInsuranceLookup(id) {
      let response = await api.get(`lookup/removeInsuranceLookup?id=${id}`)
      return response
    },
    async saveInsuranceLookup(data) {
      let response = await api.post('lookup/insuranceLookup', data)
      return response
    },
    async pushInsurance(where) {
      let response = await api.get(`lookup/pushInsurance?firm=1&where=${where}`)
      return response
    }
  }
})
